import { render, staticRenderFns } from "../templates/normal_fcont_70.html?vue&type=template&id=60464e64&"
import script from "./normal_fcont_70.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_70.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports